// socket.io @2.0.3 initially but now on latest
import io from 'socket.io-client';

export default class ClientSocketManager {

  constructor (panel, user) {
    this.panel = panel;
    this.user = user;
    this.socket = {};
    this.handler = {};
  }

  init (address, SocketHandlerClass) {
    if (!this.socket[address] || !this.socket[address].connected) {
      this.socket[address] = io.connect(address);
      if (SocketHandlerClass) {
        this.handler[address] = new SocketHandlerClass(this.panel, this.socket[address], this.user);
        this.handler[address].run();
      }
    }
  };

  getSocket (address) {
    if (this.socket[address]) {
      return this.socket[address];
    }
    return false;
  }

  getHandler (address) {
    if (this.handler[address]) {
      return this.handler[address];
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/lib/ClientSocketManager.js